exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member-file-wrapper[data-v-6dc9f808]{background-color:#f1f1f4;display:inline-block;padding:5px;width:93%;margin-right:8px}", ""]);

// exports
